import React from 'react';
import styled from '@emotion/styled';
import { Color, FontSize } from 'views/constants';
import { Typography } from 'views/components/atoms/Typography';
import { Image } from 'views/components/atoms/Image';
import logoImage from 'views/components/molecules/Header/images/logo.png';
import { Icon } from 'views/components/molecules/Icon';

// Logoは固定サイズにする
const LOGO_SIZE = '99px';
const LogoWrapper = styled.div`
  width: ${LOGO_SIZE};
`;

const IconWrapper = styled.div`
  width: 44px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface HeaderProps {
  title: string;
  logo?: boolean;
  onBack?(): void;
  onComment?(): void;
  onClick?(): void;
}

const StyledHeader = styled.header`
  height: 48px;
  background-color: ${Color.C6};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Header: React.FC<HeaderProps> = ({
  title,
  logo,
  onBack,
  onComment,
  onClick,
}) => {
  const contents = logo ? (
    <LogoWrapper>
      <Image src={logoImage} alt={title} />
    </LogoWrapper>
  ) : (
    title
  );

  const back = onBack ? (
    <Icon type="back" size="large" onClick={onBack} />
  ) : null;

  const comment = onComment ? <Icon type="edit" onClick={onComment} /> : null;

  return (
    <StyledHeader>
      <IconWrapper>{back}</IconWrapper>
      <div onClick={onClick}>
        <Typography el="h1" color={Color.C2} size={FontSize.M} bold>
          {contents}
        </Typography>
      </div>
      <IconWrapper>{comment}</IconWrapper>
    </StyledHeader>
  );
};
